import { useTranslation } from "react-i18next";
import * as z from "zod";

export const useAMLFormSchema = (isDefaultCountry = true) => {
  const { t } = useTranslation();

  return z.object({
    firstName: z
      .string({
        required_error: t("AMLFormModal.form.fields.firstName.errors.required"),
      })
      .trim()
      .min(1, t("AMLFormModal.form.fields.firstName.errors.required")),
    lastName: z
      .string({
        required_error: t("AMLFormModal.form.fields.firstName.errors.required"),
      })
      .trim()
      .min(1, t("AMLFormModal.form.fields.firstName.errors.required")),
    agreement: z.literal(true, {
      errorMap: () => ({
        message: t("AMLFormModal.form.fields.agreement.errors.required"),
      }),
    }),
    residencyId: z.number({
      required_error: t("AMLFormModal.form.fields.residencyId.errors.required"),
    }),
    ...(isDefaultCountry
      ? {
          personalCode: z
            .string({
              required_error: t(
                "AMLFormModal.form.fields.personalCode.errors.required",
              ),
            })
            .trim()
            .min(1, t("AMLFormModal.form.fields.personalCode.errors.required")),
        }
      : {
          citizenshipId: z.number({
            required_error: t(
              "AMLFormModal.form.fields.citizenshipId.errors.required",
            ),
          }),
          dateOfBirth: z.date({
            required_error: t(
              "AMLFormModal.form.fields.dateOfBirth.errors.required",
            ),
            invalid_type_error: t(
              "AMLFormModal.form.fields.dateOfBirth.errors.required",
            ),
          }),
        }),
  });
};
